export const SHOW_RESEND_TIMEOUT = 30000;
export const WARNING_TIMEOUT = 30000;
export const MS_PER_SEC = 1000;
export const UNIVERSAL_LINK_POST_DELAY = 500;
export const CANCEL_POLLING_ACTION = 'authenticatorChallenge-cancel';
export const WIDGET_FOOTER_CLASS = 'siw-main-footer';



// WEBPACK FOOTER //
// ./src/v2/view-builder/utils/Constants.js